/**
 * Workflow Node Components
 *
 * Export all custom node types for React Flow.
 */

import { BaseNode, nodeConfig } from './BaseNode';
import { StartNode } from './StartNode';
import { PromptNode } from './PromptNode';
import { GenerateNode } from './GenerateNode';
import { EditNode } from './EditNode';
import { FuseNode } from './FuseNode';
import { LuckyCharmNode } from './LuckyCharmNode';
import { PushNode } from './PushNode';
import { OutputNode } from './OutputNode';
import { ReadTodayArtifactNode } from './ReadTodayArtifactNode';

// Re-export components
export {
  BaseNode, nodeConfig,
  StartNode, PromptNode, GenerateNode, EditNode, FuseNode, LuckyCharmNode, PushNode, OutputNode,
  ReadTodayArtifactNode,
};

// Node type mapping for React Flow
export const nodeTypes = {
  start: StartNode,
  prompt: PromptNode,
  generate: GenerateNode,
  edit: EditNode,
  fuse: FuseNode,
  lucky_charm: LuckyCharmNode,
  push: PushNode,
  output: OutputNode,
  read_today_artifact: ReadTodayArtifactNode,
} as const;
